const bigIntToHex = (value) => {
    if (typeof value !== 'bigint') {
        throw new TypeError('Input must be of type BigInt');
    }
    if (value < 0) {
        throw new RangeError('Negative BigInt values are not supported');
    }
    return `0x${value.toString(16)}`;
};

export { bigIntToHex };
